import React from 'react';
import { Typography, Link } from '@mui/material';
import { useTheme } from "@mui/styles";

const ContactDevelopers = () => {
    const theme = useTheme();
    const textColor = theme.palette.mode === 'dark' ? 'white' : theme.palette.text.primary;

  const handleContactClick = () => {
    // Optional: Add your logic for contacting developers
   //  console.log("Contacting developers...");
  };

  return (
    <Typography
  style={{ color: textColor, cursor: 'pointer' }}
  variant="subtitle2"
  component={Link}
  href="mailto:yves@futurissvision.com?cc=support@futurissvision.com&subject=Developer%20Inquiry&body=Hello%20Developers%2C"
  target="_blank"
  underline="hover"
  onClick={handleContactClick} // Optional custom logic
>
  Developers &copy;futurissvision.com
</Typography>
  );
};

export default ContactDevelopers;